import React from 'react';

import JournalTable from '../common/JournalTable';
import PageTitle from '../common/PageTitle';

import {
  fetchGetImportTasks,
  fetchGetImportTaskById,
  fetchGetFieldList,
} from '../../actions/imports';

import { IMPORT_SEARCH_FIELD_TYPES } from '../../config';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const OrdersImportPage = () => {
  const { t } = useAutoTranslation();

  const handleGetTaskData = (taskData) => [
    {
      label: t('Режим поиска товаров'),
      value: (IMPORT_SEARCH_FIELD_TYPES.find((f) => f.value === taskData.searchField) || {}).label,
    },
  ];

  const handleShowReport = (task) => task.itemsFailedCount;

  return (
    <>
      <PageTitle title={t('Задачи импорта заказов')} />

      <JournalTable
        matchingWithName
        templateType="ORDER"
        newTaskLabel={t('Новый импорт')}
        newTaskUrl="/orders-import/new"
        taskName={t('Импорт заказов (Excel)')}
        getTaskData={handleGetTaskData}
        getTasksAction={fetchGetImportTasks}
        getTaskDataAction={fetchGetImportTaskById}
        detailsTitle={t('Опции загрузки')}
        showReport={handleShowReport}
        reportUrl="/imports"
      />
    </>
  );
};

export default OrdersImportPage;
